<script setup lang="ts">
import type { DiscreteNumericValueDto } from '@/api/generator';
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import { computed } from 'vue';
import { DiscreteNumericValueProps } from '../types';

const props = defineProps<DiscreteNumericValueProps>();
const discreteNumericValue = defineModel<DiscreteNumericValueDto>('discreteNumericValue');

const selectOptions = computed(() => {
  return discreteNumericValue.value?.availableValues?.map((value) => {
    return {
      title: `${value} ${discreteNumericValue.value?.unitAbbreviation}`,
      value: value,
    };
  });
});

function onUpdate(input: number | undefined) {
  if (discreteNumericValue.value) {
    discreteNumericValue.value.value = input;
  }
}
</script>

<template>
  <Autocomplete
    v-bind="props"
    :modelValue="discreteNumericValue?.value"
    :items="selectOptions"
    :chips="false"
    :clearable="!discreteNumericValue?.isRequired"
    @update:modelValue="onUpdate"
    @click:chip="onUpdate"
  />
</template>
